document.addEventListener("DOMContentLoaded", () => {
    const triggers = document.querySelectorAll('.celebrate-modal-trigger');
    const overlays = document.querySelectorAll('.modal-overlay');
      const closeButtons = document.querySelectorAll('.icon-close');
  const closeModal = (modal, overlay) => {
    modal.classList.remove('is-active');
    overlay.classList.remove('is-active');
  };

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', event => {
      event.preventDefault();
      const wrapper = trigger.closest('.wp-block-celebrate-suite-celebrate-modal-wrapper');
      if (!wrapper) return;
      const modal = wrapper.querySelector('.wp-block-celebrate-suite-celebrate-modal-window');
      const overlay = wrapper.querySelector('.modal-overlay');
      modal.classList.add('is-active');
      overlay.classList.add('is-active');
    });
    });

    overlays.forEach((overlay) => {
        overlay.addEventListener('click', () => {
            const wrapper = overlay.closest('.wp-block-celebrate-suite-celebrate-modal-wrapper');
            const modal = wrapper.querySelector('.wp-block-celebrate-suite-celebrate-modal-window');
            closeModal(modal, overlay);
        });
    });

    closeButtons.forEach((closeButton) => {
        closeButton.addEventListener('click', () => {
            const wrapper = closeButton.closest('.wp-block-celebrate-suite-celebrate-modal-wrapper');
            const overlay = wrapper.querySelector('.modal-overlay');
            const modal = wrapper.querySelector('.wp-block-celebrate-suite-celebrate-modal-window');
      closeModal(modal, overlay);
        });
    });
});
